import React from 'react';
import { FONT_BODY } from './theme';
import { STATS } from './data';

const StatsBand: React.FC = () => (
  <section id="benefits" style={{ scrollMarginTop: 74, padding: 'clamp(16px,2.4vw,28px) clamp(16px,4vw,30px)' }}>
    <div
      style={{
        maxWidth: 1180,
        margin: '0 auto',
        background: '#EFF6FF',
        borderRadius: 18,
        padding: 'clamp(22px,2.8vw,34px) clamp(18px,3vw,30px)',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,155px),1fr))',
        gap: 'clamp(14px,1.8vw,22px)',
      }}
    >
      {STATS.map((s, i) => (
        <div
          key={s.label}
          style={{
            textAlign: 'center',
            padding: '0 10px',
            ...(i > 0 ? { borderLeft: '1px solid #CFE1FA' } : {}),
          }}
        >
          <div
            style={{
              font: `800 clamp(27px,3.4vw,36px)/1 ${FONT_BODY}`,
              letterSpacing: '-.035em',
              color: '#2563EB',
            }}
          >
            {s.value}
          </div>
          <div style={{ font: `500 13.5px/1.4 ${FONT_BODY}`, color: '#475569', marginTop: 8 }}>{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsBand;
